module.exports = __webpack_public_path__ + "img/blobs-better.f138dbc.jpg";